import { useMemo } from 'react';
import { PlanKind } from 'src/types';
import styles from './OfferCardTitle.module.scss';
import { PLAN_KIND_TITLE_MAP_V2 } from 'src/constants';

export interface OfferCardTitleProps {
  planKind: PlanKind;
}

export const OfferCardTitle = ({ planKind }: OfferCardTitleProps) => {
  const planName = useMemo(() => {
    return PLAN_KIND_TITLE_MAP_V2[planKind]?.fullTitle || '';
  }, [planKind]);

  return (
    <h5 className={styles.root}>
      <span className={styles.title}>{planName}</span>
    </h5>
  );
};
